import classNames from 'classnames';
import { ReactNode } from 'react';

import styles from './UnorderedList.module.css';

type UnorderedListProps = {
    children: ReactNode;
    lineSpacing?: 'none' | 'small' | 'medium' | 'large';
    style?:
        | 'none'
        | 'none-with-indentation'
        | 'bullets'
        | 'checkmarks-green'
        | 'checkmarks-white'
        | 'checkmarks-blue';
};

const UnorderedList = ({
    children,
    lineSpacing = 'small',
    style = 'bullets',
}: UnorderedListProps) => {
    return (
        <ul
            className={classNames(styles.Root, {
                [styles.lineSpacingNone]: lineSpacing === 'none',
                [styles.lineSpacingSmall]: lineSpacing === 'small',
                [styles.lineSpacingMedium]: lineSpacing === 'medium',
                [styles.lineSpacingLarge]: lineSpacing === 'large',
                [styles.styleNone]: style === 'none',
                [styles.styleNoneWithIndentation]:
                    style === 'none-with-indentation',
                [styles.styleCheckmarksGreen]: style === 'checkmarks-green',
                [styles.styleCheckmarksWhite]: style === 'checkmarks-white',
                [styles.styleCheckmarksInBullets]: style === 'checkmarks-blue',
            })}
        >
            {children}
        </ul>
    );
};

export default UnorderedList;
